import { useEffect, useState } from "react";
import { loadModels } from "../lib/load-models";
import type { ModelPayload } from "../types/model";

interface ModelDataState {
  payload: ModelPayload | null;
  error: string | null;
}

export function useModelData(): ModelDataState {
  const [state, setState] = useState<ModelDataState>({
    payload: null,
    error: null
  });

  useEffect(() => {
    const controller = new AbortController();
    loadModels(controller.signal)
      .then((payload) => setState({ payload, error: null }))
      .catch((reason: unknown) => {
        if (reason instanceof DOMException && reason.name === "AbortError") return;
        setState({
          payload: null,
          error: reason instanceof Error ? reason.message : "Unknown data error"
        });
      });
    return () => controller.abort();
  }, []);

  return state;
}
